import {style} from 'typestyle'
import * as csstips from 'csstips'

export const WrapItem = style({
    ...csstips.flexRoot,
    paddingBottom: 16,
    paddingTop: 16,
    position: 'relative',
    textDecoration: 'none',
    $nest: {
        '&:active': {
            backgroundColor: '#f8f8f8'
        },
        '&:before': {
            background: '#E6E6E6',
            left: 143,
            bottom: 0,
            content: `""`,
            height: 1,
            position: 'absolute',
            transform: 'scaleY(0.3)',
            width: 'calc(100% - 128px)'
        }
    }
})

export const WrapItemLeft = style({
    borderRadius: 4,
    overflow: 'hidden',
    position: 'relative',
    width: 130,
    height: 73,
    $nest: {
        img: {
            width: '100%',
            height: '100%',
            borderRadius: 4
        }
    }
})

export const WrapItemRight = style({
    ...csstips.flex,
    ...csstips.vertical,
    ...csstips.betweenJustified,
    marginLeft: 12,
    width: 'calc(100% - 130px)'
})

export const MoreWonderfulModule = style({
    background: '#fff',
    borderRadius: 8,
    // boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    marginBottom: 15
})

export const rightTop = style({})

export const rightMiddle = style({
    marginTop: 6,
    marginBottom: 6
})

export const rightBottom = style({})

export const rightBottomLeft = style({
    ...csstips.flexRoot,
    ...csstips.center
})

export const popularNum = style({
    color: '#999999',
    fontSize: 12,
    letterSpacing: 0,
    position: 'relative',
    $nest: {
        img: {
            marginRight: 5,
            width: 10
        },
        span: {
            color: '#F44336'
        }
    }
})

export const titleArea = style({
    color: 'rgba(51,51,51,1)',
    fontSize: 15,
    fontWeight: 500,
    lineHeight: '22px',
    marginTop: -3
})

export const expectedLectures = style({
    marginRight: 10
})

export const moneyArea = style({
    ...csstips.flexRoot,
    ...csstips.center
})

export const RightBottonRightLimit = style({
    color: '#FF3F3C',
    fontSize: 14,
    fontWeight: 500
})

export const deleteMoney = style({
    color: '#999999',
    fontSize: 12,
    fontWeight: 400
})

export const originmoney = style({

})

export const limitMoney = style({
    marginRight: 4,
    $nest: {
        p: {
            color: '#FF5A31',
            fontSize: 15,
            fontWeight: 500
        },
        span: {
            color: '#FF5A31',
            fontSize: 15,
            fontWeight: 500
        }
    }
})

export const tags = style({
    display: 'inline-block',
    height: 16,
    marginRight: 4,
    position: 'relative',
    top: 3.5,
    width: 35
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeRecommendModule/RecommendModule.style.ts